<div class="st-rover-ai-full-screen">
    @if (mosUrl()?.length > 0) {
        <iframe
            #roverIframe
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            scrolling="yes"
            [src]="mosUrl() | unsafe: 'resourceUrl'"
            (load)="onMosLoad()"></iframe>
    }
</div>
